import { defaultLicensesEnum } from "../const";

const licenseConfigAction = {
  initializeState: "INITIALIZE_STATE",
};

const licenseConfigReducer = (state, action) => {
  switch (action.type) {
    case licenseConfigAction.initializeState:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return defaultLicensesEnum;
  }
};

export default {
  defaultState: defaultLicensesEnum,
  action: licenseConfigAction,
  reducer: licenseConfigReducer,
};
